import { render } from "./Slots.vue?vue&type=template&id=46e2cd46&scoped=true"
import script from "./Slots.vue?vue&type=script&lang=js"
export * from "./Slots.vue?vue&type=script&lang=js"

import "./Slots.vue?vue&type=style&index=0&id=46e2cd46&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46e2cd46"]])

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTable,QTd,QBtn,QPagination});
